<template>
  <v-menu v-if="currentWorkspace.settings && currentWorkspace.settings.languages" offset-y light>
    <template #activator="{ on }">
      <v-btn outlined :disabled="!isWtypeTranslatable" dark v-on="on">
        {{ currentLocale }}
        <v-icon right dark>work_outline</v-icon>
      </v-btn>
    </template>

    <v-list light class="mt-2" style="max-height: 300px; overflow: auto;">
      <v-list-item
        v-for="locale in currentWorkspace.settings.languages.allowedLocales"
        :key="locale"
        style="cursor: pointer;"
        @click="changeLocale(locale)"
      >
        <v-list-item-title v-text="locale" />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue2-helpers/vue-router';
import { useStore } from 'vue2-helpers/vuex';

import { checkIfHasChanges, clearCacheKeepAlive, refreshSearchBar } from '@/utils/pwa';

const store = useStore();
const route = useRoute();

const currentLocale = computed(() => store.getters.locale);
const currentWorkspace = computed(() => store.getters.workspace);

const changeLocale = locale => {
  checkIfHasChanges(() => {
    store.commit('setLocale', locale);
    clearCacheKeepAlive();
    refreshSearchBar();
  });
};

const wtype = computed(() => route.params.wtype);

// is wtype translatable
const isWtypeTranslatable = computed(() => {
  // Case when all content Types are translatable
  if (!wtype.value || store.getters.workspace.settings?.languages?.translatableContentTypes?.includes('*')) {
    return true;
  }

  return wtype.value && store.getters.workspace.settings?.languages?.translatableContentTypes?.includes(wtype.value);
});

</script>

<style lang="scss" rel="stylesheet/scss">
.version-select {
  margin-top: 15px !important;
}
</style>
